import type { PropsWithChildren } from "react";
import React from "react";
import clsx from "clsx";
import type { IconVariantTypes } from "../atoms/Icon.types";
import type { SpacingTypes } from "../utils/SpacingTypes";
import Icon from "../atoms/Icon";
import styles from "./Alert.module.scss";
import spacingStyles from "../utils/SpacingTypes.module.scss";

type Props = {
    className?: string;
    variant?: "default";
    icon?: IconVariantTypes;
    iconSize?: "sm" | "md";
    spacing?: SpacingTypes;
    outline?: boolean;
} & React.HTMLProps<HTMLDivElement>;

const Alert: React.FC<PropsWithChildren<Props>> = ({
    variant = "default",
    className,
    icon,
    iconSize = "sm",
    spacing,
    outline,
    children,
    ...rest
}) => {
    return (
        <div
            className={clsx(styles[variant], spacing && spacingStyles[spacing], outline && styles.outline, className)}
            {...rest}
        >
            {icon && <Icon variant={icon} sizing={iconSize} />}
            {children}
        </div>
    );
};

export default Alert;
